module.exports = "https://coursera_assets.s3.amazonaws.com/images/98862b189622017bca85264c739de852.svg";